<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">现金流待确认</span>
      <div class="h-panel-right">
        <Button color="primary" @click="reload" :loading="loading">刷新</Button>
      </div>
    </div>
    <div class="h-panel-body">
      <div class="filter-bar">
        <Row type="flex" :space="10">
          <Cell>
            <Select v-model="filter.year" placeholder="年度" :datas="yearOptions" @on-change="reload"></Select>
          </Cell>
          <Cell>
            <Select v-model="filter.month" placeholder="月份" :datas="monthOptions" @on-change="reload"></Select>
          </Cell>
          <Cell>
            <Button @click="resetFilter">重置</Button>
          </Cell>
        </Row>
      </div>

      <Table :datas="pendingList" :loading="loading" stripe border>
        <TableItem title="凭证日期" prop="voucherDate" :width="120">
          <template slot-scope="{data}">
            {{ formatDate(data.voucherDate) }}
          </template>
        </TableItem>
        <TableItem title="凭证字号" :width="120">
          <template slot-scope="{data}">
            {{ data.voucherWord }}-{{ data.voucherCode }}
          </template>
        </TableItem>
        <TableItem title="现金科目" prop="cashSubjectName" :width="150"></TableItem>
        <TableItem title="对方科目" prop="counterSubjectName" :width="150"></TableItem>
        <TableItem title="方向" :width="80">
          <template slot-scope="{data}">
            <span :class="data.cashDirection === 1 ? 'text-success' : 'text-danger'">
              {{ data.cashDirection === 1 ? '流入' : '流出' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="金额" prop="amount" :width="120" align="right">
          <template slot-scope="{data}">
            {{ formatMoney(data.amount) }}
          </template>
        </TableItem>
        <TableItem title="待确认原因" :width="150">
          <template slot-scope="{data}">
            {{ getReasonText(data.reasonCode) }}
          </template>
        </TableItem>
        <TableItem title="系统建议" :width="150">
          <template slot-scope="{data}">
            <span v-if="data.suggestedItemName" class="text-info">
              {{ data.suggestedItemName }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="200" align="center">
          <template slot-scope="{data}">
            <Button size="small" color="primary" @click="confirm(data)">确认</Button>
            <Button size="small" @click="ignore(data)">忽略</Button>
          </template>
        </TableItem>
      </Table>

      <Pagination v-if="total > 0" :total="total" :page-size="pageSize" :current-page="currentPage" @on-change="handlePageChange" />

      <Modal v-model="confirmModal.visible" :title="confirmModal.title" :width="500">
        <Form :label-width="100">
          <FormItem label="现金流项目">
            <Select v-model="confirmModal.selectedItemCode" :datas="availableCashFlowItems" filterable></Select>
          </FormItem>
          <FormItem label="保存为规则">
            <Checkbox v-model="confirmModal.saveAsRule">保存为规则，以后自动分类</Checkbox>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="confirmModal.visible = false">取消</Button>
          <Button color="primary" @click="doConfirm" :loading="confirmModal.loading">确认</Button>
        </div>
      </Modal>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CashFlowPending',
  data() {
    const currentYear = moment().year();
    return {
      loading: false,
      pendingList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filter: {
        year: currentYear,
        month: null
      },
      yearOptions: this.generateYearOptions(),
      monthOptions: this.generateMonthOptions(),
      cashFlowItems: [],
      allCashFlowItems: [],
      confirmModal: {
        visible: false,
        title: '',
        currentAllocation: null,
        selectedItemCode: '',
        saveAsRule: false,
        loading: false
      }
    };
  },
  created() {
    this.loadCashFlowItems();
    this.reload();
  },
  computed: {
    availableCashFlowItems() {
      if (!this.confirmModal.currentAllocation) {
        return this.cashFlowItems;
      }
      const direction = this.confirmModal.currentAllocation.cashDirection;
      return this.allCashFlowItems
        .filter(item => item.flowDirection === direction || item.flowDirection === 3)
        .map(item => ({
          value: item.code,
          label: `${item.name} (${item.code})`
        }));
    }
  },
  methods: {
    generateYearOptions() {
      const currentYear = moment().year();
      const options = [];
      for (let i = currentYear - 5; i <= currentYear + 1; i++) {
        options.push({ value: i, label: i + '年' });
      }
      return options;
    },
    generateMonthOptions() {
      const options = [{ value: null, label: '全部月份' }];
      for (let i = 1; i <= 12; i++) {
        options.push({ value: i, label: i + '月' });
      }
      return options;
    },
    async loadCashFlowItems() {
      try {
        const res = await this.$api.cashflow.items.list();
        if (res.success) {
          this.allCashFlowItems = res.data || [];
          this.cashFlowItems = res.data.map(item => ({
            value: item.code,
            label: `${item.name} (${item.code})`
          }));
        }
      } catch (e) {
        console.error('加载现金流项目失败', e);
      }
    },
    async reload() {
      this.currentPage = 1;
      await this.loadPendingList();
    },
    async loadPendingList() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize
        };
        if (this.filter.year) {
          params.voucherYear = this.filter.year;
        }
        if (this.filter.month) {
          params.voucherMonth = this.filter.month;
        }

        const res = await this.$api.cashflow.pending.list(params);
        if (res.success) {
          this.pendingList = res.data.records || [];
          this.total = res.data.total || 0;
        } else {
          this.$Message.error(res.msg || '加载失败');
        }
      } catch (e) {
        console.error('加载待确认列表失败', e);
        this.$Message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.loadPendingList();
    },
    resetFilter() {
      this.filter.year = moment().year();
      this.filter.month = null;
      this.reload();
    },
    confirm(allocation) {
      this.confirmModal.currentAllocation = allocation;
      this.confirmModal.title = `确认现金流分配 - 凭证 ${allocation.voucherWord}-${allocation.voucherCode}`;
      this.confirmModal.selectedItemCode = allocation.suggestedItemCode || '';
      this.confirmModal.saveAsRule = false;
      this.confirmModal.visible = true;
    },
    async doConfirm() {
      if (!this.confirmModal.selectedItemCode) {
        this.$Message.warning('请选择现金流项目');
        return;
      }

      this.confirmModal.loading = true;
      try {
        const res = await this.$api.cashflow.voucher.confirm(
          this.confirmModal.currentAllocation.id,
          this.confirmModal.selectedItemCode,
          this.confirmModal.saveAsRule
        );
        if (res.success) {
          this.$Message.success('确认成功');
          this.confirmModal.visible = false;
          this.loadPendingList();
        } else {
          this.$Message.error(res.msg || '确认失败');
        }
      } catch (e) {
        console.error('确认失败', e);
        this.$Message.error('确认失败');
      } finally {
        this.confirmModal.loading = false;
      }
    },
    async ignore(allocation) {
      this.$Modal.confirm({
        title: '确认忽略',
        content: `确定要忽略凭证 ${allocation.voucherWord}-${allocation.voucherCode} 的现金流分配吗？`,
        onOk: async () => {
          try {
            const res = await this.$api.cashflow.pending.ignore(allocation.id);
            if (res.success) {
              this.$Message.success('已忽略');
              this.loadPendingList();
            } else {
              this.$Message.error(res.msg || '操作失败');
            }
          } catch (e) {
            console.error('忽略失败', e);
            this.$Message.error('操作失败');
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('YYYY-MM-DD');
    },
    formatMoney(amount) {
      if (amount === null || amount === undefined) return '-';
      return Number(amount).toFixed(2);
    },
    getReasonText(reasonCode) {
      const reasonMap = {
        'NO_RULE': '未匹配规则',
        'RULE_CONFLICT': '规则冲突',
        'COMPLEX_ENTRY': '复合分录',
        'AMOUNT_NOT_CLOSED': '金额不闭合',
        'NO_CASH_DETAIL': '无现金明细'
      };
      return reasonMap[reasonCode] || reasonCode || '-';
    }
  }
};
</script>

<style scoped>
.filter-bar {
  margin-bottom: 15px;
}
.text-success {
  color: #19be6b;
}
.text-danger {
  color: #ed4014;
}
.text-info {
  color: #2d8cf0;
}
.text-muted {
  color: #999;
}
</style>
